export default "__VITE_ASSET__b2da8b99__"